/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { isNone } from '@ember/utils';
import { NON_SUBJECT_EMAIL_FILTERS as EMAIL_FILTERS } from 'cio/utils/email-filters';
import EmailCondition, { anyEmail } from 'cio/app-models/conditions/email';
import CampaignModel, { CampaignType, TYPE_ICONS } from 'cio/models/campaign';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';
import FiltersService from 'cio/services/filters';
import CioConditionViewerBase, { CioConditionViewerBaseArgs } from 'cio/components/cio-condition-viewer-base';

interface CioConditionViewerEmailArgs extends CioConditionViewerBaseArgs {
  condition: EmailCondition;
  campaign?: CampaignModel;
  tagName?: string;
  depth?: number;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
}

export default class CioConditionViewerEmail extends CioConditionViewerBase<CioConditionViewerEmailArgs> {
  @service filters!: FiltersService;

  @computed('emails.[]', 'args.condition.email')
  get _email() {
    return this.emails.find((m) => m.output_id === this.args.condition.email);
  }

  @computed('condition.{isAnyInParent,email}', '_email')
  get email() {
    let { condition } = this.args;

    if (!condition.isAnyInParent) {
      return this._email;
    }

    let id = condition.email.replace('any_email-campaign_', '') ?? '';
    let campaignItem = this.filters.campaigns.find((i) => i.id === id);
    return {
      isAny: true,
      isAnyInParent: true,
      subject: 'any email',
      parent: {
        type: 'campaign',
        campaignTypeIcon:
          campaignItem?.type != null ? TYPE_ICONS[campaignItem.type as CampaignType] ?? 'campaign' : 'campaign',
        name: campaignItem?.name,
      },
    };
  }

  @computed('filters.segmentable.[]', 'condition.email')
  get emails() {
    let emails = this.filters.segmentable.filterBy('type', 'email');

    return [
      {
        type: 'email',
        subject: 'any email',
        isAny: true,
        output_id: anyEmail,
        detail: 'for any campaign or newsletter',
        language: null,
      },
    ].concat(emails as any);
  }

  @computed('condition.eventType')
  get emailFilter() {
    let type = this.args.condition.eventType;
    let filter = EMAIL_FILTERS.find((f) => f.value === type);

    if (isNone(filter)) {
      return type;
    }

    return filter.label;
  }

  @computed('_email.language')
  get emailLanguage() {
    if (this._email?.language == null) {
      return '';
    }

    return this._email.language === '' ? 'Default' : this._email.language;
  }
}
